import React from 'react';
import { PET_AMENITIES_CONFIG } from '@/config/petAmenities';

// Mantiene el nombre exportado para no romper imports existentes.
export const AMENITIES_CONFIG = PET_AMENITIES_CONFIG;

// Componente para mostrar servicios en el perfil público.
// El diseño original se mantiene intacto.
const AmenitiesDisplay = ({ amenities = [] }) => {
  if (!Array.isArray(amenities) || amenities.length === 0) return null;

  const hasAnyInCategory = category =>
    category.items.some(item => amenities.includes(item.id));

  const activeCategories = Object.values(AMENITIES_CONFIG)
    .filter(hasAnyInCategory);

  if (activeCategories.length === 0) return null;

  return (
    <div
      className="bg-white rounded-2xl p-6 shadow-sm"
      data-testid="provider-amenities"
    >
      <h2 className="text-xl font-bold mb-4 text-[#000000]">
        Servicios
      </h2>

      <div className="grid sm:grid-cols-2 gap-6">
        {activeCategories.map(category => (
          <div key={category.label}>
            <h3 className="font-bold text-[#000000] mb-3 text-base">
              {category.label}
            </h3>

            <div className="space-y-2.5">
              {category.items
                .filter(item => amenities.includes(item.id))
                .map(item => {
                  const Icon = item.icon;

                  return (
                    <div
                      key={item.id}
                      className="flex items-center gap-3"
                      data-testid={`amenity-${item.id}`}
                    >
                      <Icon className="w-5 h-5 text-[#000000]" />
                      <span className="text-sm text-[#000000]">
                        {item.label}
                      </span>
                    </div>
                  );
                })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AmenitiesDisplay;
